"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.billReminderDescription = billReminderDescription;
const format_1 = require("./format");
/**
 * The "Upcoming bills" alert, described by the rule the server applies (NOT-004).
 *
 * The settings copy said "Get reminded 3 days before bills are due" on web,
 * mobile and the push-permission screen, while the alert fired from 7 days out
 * and only for bills of $200 or more. The numbers now come from the preferences
 * payload (`bill_alert_min_amount`, `bill_alert_days`), so the sentence cannot
 * drift from the rule. Before the payload loads, it says nothing numeric.
 */
function billReminderDescription(rule) {
    if (!rule)
        return "Get reminded before large bills are due";
    const amount = (0, format_1.roundMoney)(rule.minAmount).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
    });
    return `Get reminded about bills of ${amount} or more, from ${rule.days} days before they're due`;
}
//# sourceMappingURL=notificationCopy.js.map